module.exports = __webpack_public_path__ + "static/img/r-4.440349f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/renovation/r-4.jpg
// module id = bYQC
// module chunks = 0